import { PaymentPlan } from "@/components/marketplace"
import type { PaymentPlanSection } from "@/features/feed/contract"
import { resolveFeedLink } from "@/features/feed/resolve-link"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const PaymentPlanFeedSection = ({ section, context }: FeedSectionProps<PaymentPlanSection>) => {
  const { receipt, plan, cta } = section.data
  return (
    <SectionFrame section={section} context={context} gut>
      <PaymentPlan
        receiptImage={receipt.image.url}
        receiptImageAlt={receipt.image.alt ?? ""}
        receiptTitle={receipt.title}
        receiptBody={receipt.body}
        receiptSello={receipt.sello}
        planImage={plan.image?.url}
        planTitle={plan.title}
        planBody={plan.body}
        cardHeading={plan.card.heading}
        cardBrand={plan.card.brand}
        productName={plan.card.productName}
        productMeta={plan.card.productMeta}
        productImage={plan.card.productImage?.url}
        todayLabel={plan.card.todayLabel}
        todayAmount={plan.card.todayAmount}
        installments={plan.card.installments}
        totalLabel={plan.card.totalLabel}
        totalAmount={plan.card.totalAmount}
        cta={cta?.label}
        ctaHref={cta ? resolveFeedLink(cta.link, context.countryCode, context.page) : undefined}
      />
    </SectionFrame>
  )
}
